import { request } from '@/api/request';
import { STATUS_ERROR } from '@/constant';
import { GetterTree, MutationTree, ActionTree } from 'vuex';
import { RootState, ServicesState } from '@/util/interface';

const state: ServicesState = {
  services: {
    catalogs: {},
    services: []
  },
  serviceInfo: {},
  servicePaymentInfo: {},
  servicePaymentConfirm: {},
  serviceStatus: {},
  servicePaymentInfoError: {},
  servicePaymentConfirmError: {},
  fromMain: false,
  loading: false

};

const getters: GetterTree<ServicesState, RootState> = {
  services: state => state.services,
  serviceInfo: state => state.serviceInfo,
  servicePaymentConfirm: state => state.servicePaymentConfirm,
  servicePaymentInfo: state => state.servicePaymentInfo,
  serviceStatus: state => state.serviceStatus,
  servicePaymentInfoError: state => state.servicePaymentInfoError,
  servicePaymentConfirmError: state => state.servicePaymentConfirmError,
  fromMain: state => state.fromMain,
  loading: state => state.loading
};

const actions: ActionTree<ServicesState, RootState> = {
  getServices({ commit }, data = {}) {
    commit('setLoading', true);
    return request({ url:'services/catalog',
      method: 'post' ,
      data }, )
      .then((res) => {
        commit('setServices', res.data);
        return res.data;
      })
      .catch((err) => {
        if (err instanceof Error) {
          // ✅ TypeScript knows err is Error
          console.error(err.message);
        } else {
          console.error('Unexpected error', err);
        }
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },

  searchServices({ commit }, data = {}) {
    request({ 
      url:'services/catalog',
      method: 'post' ,
      data }).then((res) => {
      commit('setServices', res.data);
    });
  },

  getServiceInfo({ commit }, data) {
    commit('setLoading', true, { root: true });

    return request({ url:'services/info',
      method: 'post',
      data: data })
      .then((res) => {
        commit('setServiceInfo', res.data);
        return res.data;
      })
      .finally(() => {
        commit('setLoading', false, { root: true });
      });
  },

  payService ({ commit }, data) {
    commit('setLoading', true, { root: true });

    return request({ url: 'services/pay',
      method: 'post',
      data: data })
      .then((res) => {
        commit('setServicePaymentInfo', res.data);
        return res.data;
      })
      .catch((err) => {
        if (err && err.response && err.response.data) {
          commit('setServicePaymentInfoError', err.response.data);
        }
      })
      .finally(() => {
        commit('setLoading', false, { root: true });
      });
  },

  confirmServicePay ({ commit }, data) {
    commit('setLoading', true, { root: true });

    return request({ url: 'services/confirm',
      method: 'post',
      data: data })
      .then((res) => {
        if (res.data.status === STATUS_ERROR) {
          commit('setServicePaymentConfirmError', res.data);
        }
        commit('setServicePaymentConfirm', res.data);
        return res.data;
      })
      .catch((err) => {
        commit('setServicePaymentConfirmError', err.response.data);
        return err.response.data;
      })
      .finally(() => {
        commit('setLoading', false, { root: true });
      });
  },

  getServicesStatus  ({ commit }, data) {
    commit('setLoading', true, { root: true });

    request({ url: 'services/status',
      method: 'post',
      data: data })
      .then((res) => {
        commit('setServiceStatus', res.data);
        return res.data;
      })
      .finally(() => {
        commit('setLoading', false, { root: true });
      });
  },
  validateService ({ commit }, data) {

    return request({ url: 'services/validate_payment',
      method: 'post',
      data: data })
      .then((res) => {
        commit('setServicePaymentInfoError', res.data);
        return res.data;
      }).catch((err) => {
        if (err && err.response && err.response.data) {
          const error = err.response.data;
          commit('setServicePaymentInfoError', error);
          return error;
        }
      });
  },
  sendOtp ({ commit }, data) {
    request({ url: 'services/otp',
      method: 'post',
      data: data });
  }

};

const mutations: MutationTree<ServicesState> = {
  setServices: (state, payload) => {
    state.services = payload;
  },
  setServiceInfo: (state, payload) => {
    state.serviceInfo = payload;
  },
  setServicePaymentInfo: (state, payload) => {
    state.servicePaymentInfo = payload;
  },
  setServicePaymentInfoError: (state, payload) => {
    state.servicePaymentInfoError = payload;
  },
  setServicePaymentConfirm: (state, payload) => {
    state.servicePaymentConfirm = payload;
  },
  setServicePaymentConfirmError: (state, payload) => {
    state.servicePaymentConfirmError = payload;
  },
  setServiceStatus: (state, payload) => {
    state.serviceStatus = payload;
  },
  setFromMain: (state, payload) => {
    state.fromMain = payload;
  },
  setLoading: (state, payload) => {
    state.loading = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
  